export default __webpack_public_path__ + "static/media/entertainmentGif.5899e7e0.gif";